import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { get } from 'lodash';
import { useMemo } from 'react';
import { useLoadMore2 as useLoadMore } from '~/modules/common/hooks';

export const GET_TASK_ENTRIES = gql`
  query GetTaskEntries(
    $page: Int!
    $pageSize: Int!
    $filter: TaskEntryFilter2
    $sort: [TaskEntrySort!]
  ) {
    taskEntries: taskEntries3(
      page: $page
      pageSize: $pageSize
      filter: $filter
      sort: $sort
    ) {
      id
      project {
        id
        displayText
      }
      task {
        id
        path: fullPath {
          id
          displayText
        }
        displayText
        initialEstimatedHours
        endDate
      }
      user {
        id
        uri
        displayText
      }
      entryDate: entryDate2
      hoursWorked
      hoursRemaining
      estimatedCompletionDate: estimatedCompletionDate2
      quality
      comment
    }
  }
`;

export const useGetTaskEntries = ({
  page = 1,
  pageSize = 25,
  filter,
  sort
}) => {
  const inputVariables = useMemo(
    () => ({
      page,
      pageSize,
      filter,
      sort
    }),
    [page, pageSize, filter, sort]
  );

  const { data, loading, error, fetchMore } = useQuery(GET_TASK_ENTRIES, {
    variables: inputVariables,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  });

  const taskEntries = get(data, 'taskEntries', []);

  const { hasMore, loadingMore, loadMore } = useLoadMore({
    totalFetchedItems: taskEntries.length,
    fetchMore,
    loading,
    pageSize
  });

  return {
    loading,
    loadingMore,
    taskEntries,
    error,
    loadMore,
    hasMore
  };
};

export default useGetTaskEntries;
